module.exports = __webpack_public_path__ + "static/media/Gretchen.c1173f63.png";